import React, { useState } from 'react';
import api from '../services/api';
import useToast from '../hooks/useToast';
import ToastContainer from '../components/ToastContainer';

const YeniCalisanPage = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    department: '',
    position: '',
    startDate: '',
    birthDate: '',
    address: '',
    emergencyContact: '',
    password: '',
    confirmPassword: ''
  });
  const { toasts, addToast, removeToast } = useToast();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Form validasyonu
    if (!formData.firstName || !formData.lastName || !formData.email || !formData.password) {
      addToast('Lütfen tüm zorunlu alanları doldurun.', 'error', 5000);
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      addToast('Şifreler eşleşmiyor.', 'error', 5000);
      return;
    }

    if (formData.password.length < 6) {
      addToast('Şifre en az 6 karakter olmalıdır.', 'error', 5000);
      return;
    }

    // Email format kontrolü
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      addToast('Geçerli bir email adresi girin.', 'error', 5000);
      return;
    }

    try {
      setLoading(true);
      
      const employeeData = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        phone: formData.phone,
        department: formData.department,
        position: formData.position,
        startDate: formData.startDate,
        birthDate: formData.birthDate,
        address: formData.address,
        emergencyContact: formData.emergencyContact,
        password: formData.password
      };

      await api.createEmployee(employeeData);
      
      addToast('Yeni çalışan başarıyla kaydedildi!', 'success', 5000);
      
      // Formu temizle
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        department: '',
        position: '',
        startDate: '',
        birthDate: '',
        address: '',
        emergencyContact: '',
        password: '',
        confirmPassword: ''
      });

    } catch (error) {
      console.error('Çalışan kaydedilirken hata:', error);
      addToast('Çalışan kaydedilirken bir hata oluştu. Lütfen tekrar deneyin.', 'error', 5000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modern-hr-page">
      <div className="container-fluid">
        <div className="modern-hr-header">
          <h1>Yeni Çalışan Kaydı</h1>
          <p>Yeni çalışan bilgilerini sisteme kaydedin</p>
        </div>

        <div className="modern-hr-widget">
          <div className="modern-hr-widget-header">
            <div className="modern-hr-widget-title">
              <i className="bx bx-user-plus"></i>
              <h4>Çalışan Bilgileri</h4>
            </div>
            <p className="modern-hr-widget-subtitle">Tüm alanları eksiksiz doldurun</p>
          </div>

          <form onSubmit={handleSubmit} className="modern-hr-form">
            <div className="row">
              {/* Kişisel Bilgiler */}
              <div className="col-md-6">
                <div className="modern-hr-section">
                  <h5 className="modern-hr-section-title">
                    <i className="bx bx-user"></i>
                    Kişisel Bilgiler
                  </h5>
                  
                  <div className="modern-hr-form-group">
                    <label className="modern-hr-form-label">
                      Ad <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleInputChange}
                      className="modern-hr-form-input"
                      placeholder="Adınızı girin"
                      required
                    />
                  </div>

                  <div className="modern-hr-form-group">
                    <label className="modern-hr-form-label">
                      Soyad <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleInputChange}
                      className="modern-hr-form-input"
                      placeholder="Soyadınızı girin"
                      required
                    />
                  </div>

                  <div className="modern-hr-form-group">
                    <label className="modern-hr-form-label">
                      Email <span className="text-danger">*</span>
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className="modern-hr-form-input"
                      placeholder="ornek@kolin.com.tr"
                      required
                    />
                  </div>

                  <div className="modern-hr-form-group">
                    <label className="modern-hr-form-label">Telefon</label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      className="modern-hr-form-input"
                      placeholder="(555) 555 55 55"
                    />
                  </div>

                  <div className="modern-hr-form-group">
                    <label className="modern-hr-form-label">Doğum Tarihi</label>
                    <input
                      type="date"
                      name="birthDate"
                      value={formData.birthDate}
                      onChange={handleInputChange}
                      className="modern-hr-form-input"
                    />
                  </div>

                  <div className="modern-hr-form-group">
                    <label className="modern-hr-form-label">Adres</label>
                    <textarea
                      name="address"
                      value={formData.address}
                      onChange={handleInputChange}
                      className="modern-hr-form-textarea"
                      placeholder="Adres bilginizi girin"
                      rows="3"
                    />
                  </div>

                  <div className="modern-hr-form-group">
                    <label className="modern-hr-form-label">Acil Durum İletişim</label>
                    <input
                      type="text"
                      name="emergencyContact"
                      value={formData.emergencyContact}
                      onChange={handleInputChange}
                      className="modern-hr-form-input"
                      placeholder="Acil durum iletişim bilgisi"
                    />
                  </div>
                </div>
              </div>

              {/* İş Bilgileri */}
              <div className="col-md-6">
                <div className="modern-hr-section">
                  <h5 className="modern-hr-section-title">
                    <i className="bx bx-briefcase"></i>
                    İş Bilgileri
                  </h5>
                  
                  <div className="modern-hr-form-group">
                    <label className="modern-hr-form-label">
                      Departman <span className="text-danger">*</span>
                    </label>
                    <select
                      name="department"
                      value={formData.department}
                      onChange={handleInputChange}
                      className="modern-hr-form-select"
                      required
                    >
                      <option value="">Departman seçin</option>
                      <option value="Saha Mühendisliği">Saha Mühendisliği</option>
                      <option value="Muhasebe">Muhasebe</option>
                      <option value="İnsan Kaynakları">İnsan Kaynakları</option>
                      <option value="Satış">Satış</option>
                      <option value="Pazarlama">Pazarlama</option>
                      <option value="IT">IT</option>
                      <option value="İdari İşler">İdari İşler</option>
                    </select>
                  </div>

                  <div className="modern-hr-form-group">
                    <label className="modern-hr-form-label">
                      Pozisyon <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="position"
                      value={formData.position}
                      onChange={handleInputChange}
                      className="modern-hr-form-input"
                      placeholder="Pozisyonunuzu girin"
                      required
                    />
                  </div>

                  <div className="modern-hr-form-group">
                    <label className="modern-hr-form-label">
                      İşe Başlama Tarihi <span className="text-danger">*</span>
                    </label>
                    <input
                      type="date"
                      name="startDate"
                      value={formData.startDate}
                      onChange={handleInputChange}
                      className="modern-hr-form-input"
                      required
                    />
                  </div>
                </div>

                {/* Güvenlik Bilgileri */}
                <div className="modern-hr-section">
                  <h5 className="modern-hr-section-title">
                    <i className="bx bx-lock"></i>
                    Güvenlik Bilgileri
                  </h5>
                  
                  <div className="modern-hr-form-group">
                    <label className="modern-hr-form-label">
                      Şifre <span className="text-danger">*</span>
                    </label>
                    <input
                      type="password"
                      name="password"
                      value={formData.password}
                      onChange={handleInputChange}
                      className="modern-hr-form-input"
                      placeholder="En az 6 karakter"
                      required
                    />
                  </div>

                  <div className="modern-hr-form-group">
                    <label className="modern-hr-form-label">
                      Şifre Tekrar <span className="text-danger">*</span>
                    </label>
                    <input
                      type="password"
                      name="confirmPassword"
                      value={formData.confirmPassword}
                      onChange={handleInputChange}
                      className="modern-hr-form-input"
                      placeholder="Şifrenizi tekrar girin"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Form Butonları */}
            <div className="modern-hr-form-actions">
              <button
                type="button"
                className="modern-hr-btn modern-hr-btn-secondary"
                onClick={() => window.history.back()}
              >
                <i className="bx bx-arrow-back"></i>
                Geri Dön
              </button>
              <button
                type="submit"
                className="modern-hr-btn modern-hr-btn-primary"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <i className="bx bx-loader-alt bx-spin"></i>
                    Kaydediliyor...
                  </>
                ) : (
                  <>
                    <i className="bx bx-save"></i>
                    Çalışanı Kaydet
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Toast Container */}
      <ToastContainer toasts={toasts} removeToast={removeToast} />
    </div>
  );
};

export default YeniCalisanPage;
